export { default } from './web/ClipboardModule';
